import { HeaderLogo } from 'components/Header/HeaderLogo';
import { FC } from 'react';

import styles from './MinimalHeader.module.less';

const DTI = 'Header';

export const MinimalHeader: FC = () => {
  return (
    <header data-testid={DTI} className={styles.container}>
      <HeaderLogo data-testid={`${DTI}__Logo`} />
    </header>
  );
};
